import React, {useRef, useState} from 'react';

import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {BreadcrumbsList} from "./breadcrumbs.list";
import {BreadcrumbsCollapsedList} from "./breadcrumbs.collapsed-list";
import {BREADCRUMBS} from "./breadcrumbs.consts";
import styles from "./breadcrumbs.module.scss"
import classNames from "classnames";
import {observer} from 'mobx-react';

class BreadcrumbsProps extends BaseProps {
}

export const Breadcrumbs = observer(({controller, visible, hasData}: BreadcrumbsProps) => {
  const ref = useRef(null);
  const [contentWidth, setContentWidth] = useState(0);
  const {device, state} = controller;
  const {isSmallView} = device;
  const {breadcrumbsList} = state;
  const shouldRenderDots: Boolean = breadcrumbsList?.length > 2 && contentWidth > controller.device.screenWidth && !controller.device.isLargeView;

  const calcWidth = () => {
    const refWidth = ref.current?.getBoundingClientRect().width + BREADCRUMBS.CONTENT_OFFSET;

    setContentWidth(refWidth)
  }

  return (
    <div className={classNames(styles.container, {[styles.small_view]: isSmallView, [styles.visible]: visible})}>
      {
        hasData ? <div className={classNames(styles.content)} ref={ref}>
          {
            shouldRenderDots ? <BreadcrumbsCollapsedList controller={controller}/> :
              <BreadcrumbsList controller={controller} onRenderComplete={calcWidth}/>
          }
        </div> : null
      }
    </div>
  )
});
